{
  "title": "如何接受評審邀請並登入",
  "description": "收到主辦方的評審邀請後，啟用帳號並登入評審系統。",
  "headings": ["你會完成什麼", "適用角色", "操作前確認", "操作步驟", "完成後", "常見問題"],
  "summary": "完成後，您會以評審身分登入，並能看到指派給您的作品清單。",
  "roleNote": "評審",
  "prerequisites": ["已收到主辦方寄送的評審邀請信"],
  "pathLabel": "登入頁",
  "steps": [
    {
      "title": "1. 查看邀請信",
      "description": "主辦方以 Email 寄送評審邀請。若您的 Email 已有平台帳號，信件只會請您登入，不會附上任何密碼；若尚無帳號，信件會附上一組僅供本人使用的臨時初始密碼。"
    },
    {
      "title": "2. 已有帳號：登入後接受或婉拒",
      "description": "以既有帳號密碼登入後，在「總覽」頁的「待回覆的評審邀請」按「接受邀請」；接受後才會成為該競賽的評審，並可點「前往評審任務」進入工作區。若無法擔任，按「婉拒」並可填寫原因，主辦方會在邀請列表看到「已婉拒」與原因。邀請的回覆期限為 7 天。"
    },
    {
      "title": "3. 新帳號：使用臨時密碼登入",
      "description": "使用信件中的帳號 Email 與臨時密碼登入；臨時密碼有時效限制（目前為 48 小時，未來可能調整）。登入成功後，畫面會直接顯示「請設定您的新密碼」畫面（取代平台其餘內容），輸入至少 10 個字元的新密碼並送出即完成；完成前無法存取任何評審或競賽保護資料，僅頁首的帳號選單（含登出）仍可操作。送出成功後系統會自動載入評審工作區，不需要重新整理或重新登入。"
    }
  ],
  "afterward": [
    "登入後可看到評審工作區",
    "指派給您的作品會出現在清單中",
    "系統之後的通訊一律寄送到您登入用的 Email"
  ],
  "nextSteps": "接著可以前往評審工作區，查看目前指派給您的作品並開始評分。",
  "faq": [
    {
      "q": "臨時密碼過期或找不到了怎麼辦？",
      "a": "臨時密碼只在產生後的單次通知信中出現，資料庫只保存雜湊值，無法查詢。最快的方式是在登入頁使用「忘記密碼」，以邀請信所寄的 Email 收取重設連結並設定新密碼，完成後即可直接登入並成為評審；也可以請主辦方在「評審邀請與指派」頁點選「重新發送」，會產生新密碼並讓舊密碼立即失效。建議使用日常會收信的 Email（例如 Gmail）作為受邀信箱。"
    },
    {
      "q": "第一次登入後看到「請設定您的新密碼」畫面，這是正常的嗎？",
      "a": "是的，這是預期行為，不是卡住。以臨時密碼登入的第一次都會先看到這個畫面，取代平台其餘內容；輸入新密碼並送出後就會自動繼續，不需要重新整理或重新登入頁面。"
    }
  ]
}
